<template>
  <div :class="[{ 'customs-tools': PACKAGE_NAME == 'Customizer' }]">
    <template v-if="isConfiguratorLoaded && isTranslationLoaded">
      <preloader></preloader>
      <div v-if="regionIsApac" id="master-container" class="wroot">
        <section id="body-container">
          <div class="configurator main">
            <div id="masthead" class="masthead header" role="banner">
              <china-headers v-if="locale === 'zh_cn'"></china-headers>
              <korea-headers v-else-if="locale === 'ko_kr'"></korea-headers>
            </div>
            <buy-panel></buy-panel>
            <customizer></customizer>
          </div>
        </section>
      </div>
      <template v-else>
        <customizer
          :class="[ {
            'hide-external-headers': !$store.state.utils.externalHeadersVisible || noEsiActive || $store.getters['utils/vsfActive'],
            'hide-external-headers-canvas': canvasActive
          } ]"
        >
          <buy-panel></buy-panel>
        </customizer>
      </template>
    </template>
  </div>
</template>
<script>
import buyPanel from '@/components/BuyPanel';
import preloader from '@/components/Customizer/Preloader';
import chinaHeaders from '@/components/Customizer/ExternalIncludes/ChinaHeaders';
import koreaHeaders from '@/components/Customizer/ExternalIncludes/KoreaHeaders';
import customizer from '@/components/Customizer';
import { getRegion, getLocale, getCaid, getDomain, getConfigurationObject } from "@/data/regionInfo";
import returnQueryParams from "@/http/returnQueryParams";
const throttle = require("lodash/throttle");

export default {
  name: "customizer-view",
  components: {
    buyPanel,
    preloader,
    chinaHeaders,
    koreaHeaders,
    customizer
  },
  props: {
    queryParameters: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isConfiguratorLoaded: false,
      isTranslationLoaded: false,
      throttledSetWindowDimensions: null,
      PACKAGE_NAME: ''
    };
  },
  computed: {
    configuration() {
      return this.$store.state.utils.configuration;
    },
    domain() {
      return this.$store.state.utils.configuration.domain;
    },
    locale() {
      return this.$store.state.utils.configuration.locale;
    },
    queryParams() {
      return this.$store.state.utils.queryParams;
    },
    pdmModel() {
      const pathName = window.location.pathname;
      const splitPath = pathName.split('.');
      return this.queryParams.model || splitPath[1];
    },
    regionIsApac() {
      return this.$store.getters['utils/regionIsApac'];
    },
    isApparelEnabled() {
      return this.$store.getters['utils/isApparelEnabled'];
    },
    noEsiActive() {
      return this.$store.getters['utils/noEsiActive'];
    },
    enablePerformanceLogging() {
      return this.$store.state.utils.queryParams.enablePerformanceLogging || this.$store.state.utils.configuration.enablePerformanceLogging;
    },
    initialTime() {
      return this.$store.state.utils.initialTime;
    },
    canvasActive() {
      return this.$store.getters["utils/canvasActive"];
    }
  },
  methods: {
    loadLocale(domain) {
      if (this.locale) {
        this.isTranslationLoaded = true;
        this.$store.commit('utils/CHANGE_VISIBILITY_EXTERNAL_HEADERS', this.regionIsApac);

        const wcsEsiIncludes = document.getElementById('wcsEsiIncludes');
        if (wcsEsiIncludes && this.regionIsApac) { // Hide wcsEsiIncludes if region is apac
          wcsEsiIncludes.classList.add('hide');
        } else if (wcsEsiIncludes && this.canvasActive) { // Hide wcsEsiIncludes if region is apac
          wcsEsiIncludes.classList.add('wcsEsiIncludes-canvas');
        } else { // Move WCS elements to accurate position
          const headerContainer = document.querySelectorAll('div.topnav');
          if (!!headerContainer.length) {
            const pageUtil = document.querySelectorAll('article.page-util');
            if (!!pageUtil.length) {
              headerContainer[0].appendChild(pageUtil[0]);
            }
          }
        }
      }
    },
    setWindowDimensions() {
      // updates the store attribute since the window object is not reactive
      this.$store.commit("utils/SET_WINDOW_WIDTH", window.innerWidth);
    },
  },
  created() {
    const {
      VERSION,
      NODE_ENV,
      VUE_APP_DOMAIN,
      VUE_APP_PUBLIC_PATH,
      VUE_APP_ENDPOINTS,
      VUE_APP_ENV,
      VUE_APP_CAID,
      PACKAGE_NAME
    } = process.env;
    this.PACKAGE_NAME = PACKAGE_NAME;
    const isProduction = NODE_ENV === 'production';

    console.info('Vue Customizer', VERSION);
    if(this.enablePerformanceLogging) {
      this.$store.commit("utils/SET_INITIAL_TIME", new Date().getTime() / 1000);
      console.log("Performance Logging initialTime started:");
    }

    const urlParams = returnQueryParams();
    if (Object.keys(urlParams).length > 0) this.$store.commit('utils/SET_QUERY_PARAMS', urlParams);
    if (this.canvasActive) {
      const parentUrlParams = returnQueryParams(this.canvasActive);
      this.$store.commit('utils/SET_QUERY_PARAMS', parentUrlParams);
    }

    if (this.$props.queryParameters) {
      this.$store.commit('utils/SET_QUERY_PARAMS', this.$props.queryParameters);
    }

    const configObject = getConfigurationObject() || {};

    // Get CAID from queryParams
    if(this.queryParams.caid || VUE_APP_CAID || this.canvasActive) {
      const caid = this.queryParams.caid || VUE_APP_CAID;
      this.$store.commit('utils/SET_CAID', caid);
      this.$store.commit('utils/SET_CONFIGURATION', { region: getRegion(), locale: getLocale(), domain: this.queryParams.domainName || `https://${getDomain()}`});
    }

    const domain = (!this.domain && configObject && configObject.domain) ? configObject.domain : this.domain || process.env.VUE_APP_DOMAIN;
    this.$store.commit("utils/SET_IS_PRODUCTION", isProduction);
    if (isProduction) {
      this.$store.commit('endPoints/SET_PUBLIC_PATH', domain + VUE_APP_PUBLIC_PATH);
    }
    if (this.noEsiActive) {
      this.$customsGTM.GTMScript();
    }
    this.$store.commit('utils/SET_ENV', this.queryParams.env || VUE_APP_ENV);
    this.$store.commit('endPoints/SET_ENDPOINTS', { endpoints: { endpoints: VUE_APP_ENDPOINTS }, type: 'customizer' });
    if(getCaid()) {
      this.$store.commit('utils/SET_CONFIGURATION', { region: getRegion(), locale: getLocale(), domain});
    } else {
      this.$store.commit('utils/SET_CONFIGURATION', { region: "north-america", locale: "en_us", domain: "https://qa2.vans.com" });
    }

    this.$nextTick(() => {
      this.$store.commit('utils/SET_CAID', getCaid().caid);
      this.loadLocale(domain);
      this.$store.commit('utils/SET_PDM_MODEL', this.pdmModel);
      this.$store.dispatch('endPoints/LOAD_LIBRARY_ENPOINTS', {
        domain,
        type: 'customizer'
      })
        .then(() => {
          if(this.enablePerformanceLogging)
            console.log("Endpoints Ready: ", new Date().getTime() / 1000 - this.initialTime);

          return this.$store.dispatch('utils/GET_CONFIGURATION');
        })
        .then(configuration => {
          if(this.enablePerformanceLogging)
            console.log("LOAD configuration Ready: ", new Date().getTime() / 1000 - this.initialTime);
          if (this.$store.state.utils.queryParams.canvas) this.$store.dispatch("utils/FETCH_HEADERS_DATA");

          if(!this.queryParams.enrollment_marketing_source && configuration?.enableEnrollmentMarketingSource) {
            const queryparam = configuration?.enrollmentMarketingSourceParam;
            const querySymbol = Object.keys(urlParams).length > 0 ? "&" : "?";
            document.location.href=`${document.location.href}${querySymbol}enrollment_marketing_source=${queryparam}`;
          }
          // TODO: remove once apparel launches
          if (configuration?.apparel_settings?.models_enabled) {
            const apparelModels = configuration.apparel_settings?.models_enabled;
            if (!this.isApparelEnabled && apparelModels.includes(this.pdmModel)) {
              console.error("This model is not supported in this region");
              return false;
            }
          }

          if (!configuration.models_enabled.includes(this.pdmModel)) {
            console.error("This model is not supported in this region");
            if(!this.canvasActive) window.location.href = `https://www.${window.location.host.replace("customs.","")}`
            return false;
          }

          // Hardcoding caid value (temporary solution?) and changing swatchesbucket from prod to use a s3Customizer folder
          if(this.configuration.enableS3Customizer) {
            this.$store.commit('utils/SET_CAID', "nora-en-us-vans");
            const {s3SwatchesBucket,s3Url} = this.$store.state.endPoints.customizer;
            this.$store.commit('endPoints/SET_ENDPOINTS', { endpoints: { s3SwatchesBucket: `${s3SwatchesBucket.replace(s3Url,'')}`}, type: 'customizer' });
          }

          this.isConfiguratorLoaded = true;
        })
        .then(() => {
          if (this.$customsMonetateQ) this.$customsMonetateQ.logEvent(this.$customsMonetateQ.type.setPageType, 'Customizer');
        });
    });
    this.setWindowDimensions();
    // the window size is updated whenever the windows is resized or the orientation changes, and the
    // throttle wrapper makes sure the original method doesn't get called too many times in a short interval
    this.throttledSetWindowDimensions = throttle(this.setWindowDimensions, 200);
    window.addEventListener('resize', this.throttledSetWindowDimensions);
    window.addEventListener('orientationchange', this.throttledSetWindowDimensions);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.throttledSetWindowDimensions);
    window.removeEventListener('orientationchange', this.throttledSetWindowDimensions);
  },
};
</script>
<style lang="scss">
  @import "@/styles/global.scss";

  .customs-tools {
    overflow: visible !important;
  }
</style>
